module.exports = __webpack_public_path__ + "static/media/bg_price_plan_over_50.cecd8f8e.webp";